<template>
  <div>
    <step1 v-if="st1" @sendQuery="setQuery($event,2)" @sendEntity="setEntity($event)"></step1>
    <step2 v-if="st2" @sendQuery="setQuery($event,3)" :query="query" :entity="entity" @sendTable="setTableData($event)"></step2>
    <search-table v-if="st3" @sendQuery="setQuery($event,4)" :tableData="tableData"></search-table>
  </div>
</template>

<script>
  import step1 from './Step1';
  import step2 from './Step2';
  import searchTable from './SearchTable';

  export default {
    name: 'addFilters',
    components: {
      step1,
      step2,
      searchTable
    },
    data: function () {
      return {
        topmenu: [
          {
            name: 'Volver',
            path: '/search/list',
            brand: 'fa fa-arrow-left'
          },
        ],
        query: null,
        entity: null,
        tableData: null,
        st1: true,
        st2: false,
        st3: false
      }
    },
    mounted() {
      this.$eventHub.$emit('captureMenu', this.topmenu);
    },
    methods: {
      setQuery(query, step) {
        this.query = query;
        switch (step) {
          case 2:
            this.st1 = false;
            this.st2 = true;
            break;
          case 3:
            this.st1 = false;
            this.st2 = false;
            break;
          case 4:
            this.st1 = false;
            this.st2 = false;
            this.st3 = true;
          default:
            this.query = null;
            this.st1 = true;
            this.st2 = false;
        }
      },
      setEntity(entity) {
        this.entity = entity;
      },
      setTableData(data) {
        if(data && data[0]){
          this.tableData = data['0'];
        } else {
          this.tableData = data;
        }
      }
    }
  }
</script>
